import { Link } from 'react-router-dom'
import { primaryButtonClass } from '@/components/common/formStyles'
import type { ImportResultResponse } from '@/types/import'

interface ResultCardProps {
  result: ImportResultResponse
  onNewImport: () => void
}

export function ResultCard({ result, onNewImport }: ResultCardProps) {
  const { summary, audit_log_id } = result
  const linkClass =
    'tracked-caps border border-hairline px-6 py-3 text-[11px] text-ink transition-colors hover:bg-panel'

  return (
    <section className="hairline mt-6 flex flex-col gap-4 border border-gain/40 bg-gain/5 p-6">
      <header>
        <p className="tracked-caps text-xs text-gain">✓ Import erfolgreich</p>
      </header>

      <ul className="space-y-1 text-sm text-ink">
        <li>{summary.trades_new} Trades importiert</li>
        <li>{summary.positions_new} neue Positionen erstellt</li>
        <li>{summary.trades_skipped_duplicates} Duplikate übersprungen</li>
        <li>{summary.trades_skipped_sells} SELL übersprungen (Folge-Session)</li>
      </ul>

      <p className="font-mono text-xs text-muted">AuditLog #{audit_log_id}</p>

      <div className="flex gap-3">
        <Link to="/positions" className={primaryButtonClass}>
          Zu Positionen
        </Link>
        <button type="button" onClick={onNewImport} className={linkClass}>
          Weiteren Import starten
        </button>
      </div>
    </section>
  )
}
